import styled from "styled-components/macro";

export const FlexContainer = styled.div`
  display: flex;
  flex-wrap: no-wrap;
  @media ${(props) => props.theme.media.tablet} {
    flex-wrap: wrap;
  }
  @media ${(props) => props.theme.media.phone} {
    flex-wrap: wrap;
    width: 90vw;
    padding: 0 6px;
  }
`;

export const AboutStudent = styled.div`
  margin-right: 1rem;
  width: 49%;
  min-width: 530px;
  max-width: 530px;
  overflow-wrap: break-word;
  & > * {
    word-break: break-word;
  }
  @media screen and (max-width: 1200px) {
    min-width: 360px;
    max-width: 360px
  }
  @media ${(props) => props.theme.media.tablet} {
    width: 100%;
    margin-right: 0;
  }
  @media ${(props) => props.theme.media.phone} {
    width: 100%;
    min-width: 100%;
  }
  .title {
    font-size: 20px;
    line-height: 130%;
    color: ${(props) => props.theme.colors.text};
    margin-bottom: 1rem;
  }
  .description {
    font-size: 1rem;
    line-height: 130%;
    color: ${(props) => props.theme.colors.text};
    // margin-top: 20px;
  }
`;

export const ImageTextContainer = styled.div`
  display: flex;
  margin-top: 20px;
  img {
    margin-right: 24px;
    width: 84px;
    height: 84px;
    border-radius: 50%;
    object-fit: cover;
  }
  .textContainer {
    & p {
      font-size: 1rem;
      line-height: 130%;
      color: ${(props) => props.theme.colors.text};
      .expText {
        font-size: 12px;
        line-height: 150%;
      }
      span {
        font-weight: 600;
      }
    }
    .name {
      margin-bottom: 0.5rem;
      color: ${(props) => props.theme.colors.text};
      font-size: 1rem;
      line-height: 130%;
      font-weight: 600;
    }
  }
`;

export const AboutStudentList = styled.ul`
  margin: 0.5rem 0;
  li {
    font-size: 1rem;
    line-height: 130%;
    color: ${(props) => props.theme.colors.text};
    list-style-type: none;
  }
`;


export const SocialPreference = styled.div`
  width: 49%;
  min-width: 530px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media screen and (max-width: 1200px) {
    min-width: 360px;
  }
  @media ${(props) => props.theme.media.tablet} {
    width: 100%;
  }
  @media ${(props) => props.theme.media.phone} {
    width: 100%;
    min-width: 100%;
  }
  & > button {
    margin-bottom: 24px;
  }
`;
